import React from "react";
import { getMailBoxParams } from "./gateway";
import { useQuery } from "react-query";

function useGetMailBoxParams() {
  return useQuery({
    queryFn: getMailBoxParams,
    queryKey: ["getMailBoxParams"],
  });
}

export default useGetMailBoxParams;
